import React from 'react';
import { Row, Col, Grid, Space } from 'antd';

import SaveAsDraftButton from './Buttons/SaveAsDraftButton';
import SaveButton from './Buttons/SaveButton';
import PrintButton from './Buttons/PrintButton';
import BackButton from './Buttons/BackButton';

const { useBreakpoint } = Grid;

const ButtonGroupComponent = ({ 
	currentStep,
	loadingSubmit,
	draftDisabled,
	saveDisabled,
	onSave,
	onPrevious,
	applicationStatus='draft',
	htmlType='submit',
	isOnReviewPage=false,
	isOnPersonalPage=false,
	isApplicationStatusPage
}) => {
	const screens = useBreakpoint();
	return (
		<>
			{screens.xxl || screens.xl || screens.lg || screens.md ?
				<>
					<Row justify="space-between">
						<Col
							align="start"
							span={12} 
							style={{ marginBottom: 20 }}
						>
							{applicationStatus === 'draft' && isOnPersonalPage === false &&
							<BackButton 
								style={{ borderColor: 'black' }}
								onPrevious={onPrevious}
							/>
							}
						</Col>
						<Col
							align="end"
							span={12}
							style={{ marginBottom: 20 }}
						>
							<Space>
								{applicationStatus === 'draft' && isOnReviewPage === false &&
								<SaveAsDraftButton 
									loading={loadingSubmit}
									disabled={draftDisabled || loadingSubmit}
									htmlType={htmlType}
								/>
								}
								{!isApplicationStatusPage &&
								<SaveButton 
									label={isOnReviewPage ? 'Submit' : currentStep === 6 && !isOnReviewPage ? 'Review' : applicationStatus !== 'draft' ? 'Submit' : 'Next'}
									onClick={onSave}
									loading={loadingSubmit}
									disabled={saveDisabled || loadingSubmit}
									htmlType={htmlType}
									style={{ width: 100 }}
								/>
								}
							</Space>
						</Col>
					</Row> 
					{isApplicationStatusPage && applicationStatus !== 'draft' && isOnReviewPage === false &&
					<Row justify="end">
						<Col 
							style={{ marginBottom: 20 }}
						>
							<PrintButton style={{ width: 100 }}/>
						</Col>
					</Row>
					}
				</>
				:
				<Row>
					{applicationStatus === 'draft' && isOnReviewPage === false &&
					<Col 
						span={24}
						style={{ marginBottom: 20 }}
					>
						<SaveAsDraftButton 
							loading={loadingSubmit}
							disabled={draftDisabled || loadingSubmit}
							style={{ width: '100%' }}
							htmlType={htmlType}
						/>
					</Col>
					}
					<Col 
						span={24}
						style={{ marginBottom: 20 }}
					>
						{!isApplicationStatusPage &&
						<SaveButton 
							label={isOnReviewPage === true ? 'Submit' : currentStep === 6 && isOnReviewPage === false ? 'Review' : applicationStatus === 'submitted' ? 'Submit' : 'Next'}
							onClick={onSave}
							loading={loadingSubmit}
							disabled={saveDisabled || loadingSubmit}
							style={{ width: '100%' }}
							htmlType={htmlType}
						/>
						}
					</Col>
					{isApplicationStatusPage && applicationStatus !== 'draft' && isOnReviewPage === false &&
					<Col 
						span={24}
						style={{ marginBottom: 20 }}
					>
						<PrintButton style={{ minWidth: '100%' }}/>
					</Col>
					}
					{applicationStatus === 'draft' && isOnPersonalPage === false &&
					<Col 
						span={24}
						style={{ marginBottom: 20 }}
					>
						<BackButton 
							style={{ width: '100%', borderColor: 'black' }}
							onPrevious={onPrevious}
						/>
					</Col>
					}
				</Row>
			}
		</>
	);
};

export default ButtonGroupComponent;